import { createFileRoute } from '@tanstack/react-router';
import Unauthorized from '../components/Unauthorized';

/**
 * Unauthorized (403) Route
 *
 * This route is shown when a user tries to access a page they don't have permission for.
 * Users are redirected here from routes that fail permission checks in beforeLoad.
 */
export const Route = createFileRoute('/unauthorized')({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: UnauthorizedRoute,
});

function UnauthorizedRoute() {
  return <Unauthorized />;
}
